export const OVERLAY_TRANSITION = 'transition-transform duration-300 ease-in-out'

export const floatingPlacement = (side, collapsed) => ({
  top: 0,
  bottom: 0,
  [side]: 0,
  transform: collapsed ? `translateX(${side === 'left' ? '-100%' : '100%'})` : undefined,
})
